<script>
import MultipleRadios from "@/pages/components/form/input-only/multiple-radios.vue";
import Input from "@/pages/components/form/input-only/input.vue";

export default {
  components: { MultipleRadios, Input },
  props: {
    modelValue: {
      required: true,
    },
    name: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    extra: {
      required: false,
      type: String,
    },
    callback: {
      required: true,
    },
    groupClasses: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      default: true,
    },
    cylinders: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      inputValue: this.modelValue,
      customValue: this.customValue,
      midTester: this.midTester,
    };
  },
  computed: {
    currentCylinder() {
      let match = this.name.match(/measurement_mixture_(l|e|f|g)_(co|co2|ppm|o2)/);
      if (!match) {
        Helpers.Message.error('Unknown mixture type');
        return null;
      }

      let mixtureType = `mixture_${match[1]}`;

      return this.cylinders.find(cylinder => cylinder.type === mixtureType);
    },
    isWithinMargin() {
      let cylinder = this.currentCylinder;

      if (cylinder !== undefined && cylinder !== null) {
        let property = this.name.split('_').pop();
        this.customValue = cylinder[property];

        return this.callback(this.customValue, this.inputValue, property, 0);
      }
      return false;
    },
    computedValue() {
      return this.isWithinMargin ? 'OK' : 'Fout';
    }
  },
  methods: {
    handleInput(value) {
      this.inputValue = value;
      this.$emit('update:modelValue', value);
    },
  },
}
</script>

<template>
  <div class="form-group row" :class="{ [groupClasses]: typeof groupClasses != 'undefined' }">
    <div class="col-4">
      <label class="form-label">{{ label }}</label>
      <label class="form-label ms-2"> ± {{ this.customValue }}</label>
    </div>

    <div class="col-4">
      <Input
          v-bind="$attrs"
          :name="name"
          :model-value="inputValue"
          :required="required"
          @update:modelValue="handleInput"
      />
    </div>

    <div class="col-4">
      <MultipleRadios
          v-bind="$attrs"
          :name="name"
          :model-value="computedValue"
          :required="required"
          :options="[
          { label: 'OK', value: 'OK' },
          { label: 'Fout', value: 'Fout' },
        ]"
          disabled="disabled"
      />
    </div>
  </div>
</template>